import { gql } from "@apollo/client";

export const FIND_STATEMENT_BY_PLAN = gql`
  query FindStatementByPlan($uuid: ID!) {
    findStatementByPlan(uuid: $uuid) {
      corporateObjectiveSummary
      corporatePlanScopeSummary
      uuid
    }
  }
`;

export const UPDATE_STATEMENT = gql`
  mutation UpdateStatement($data: UpdateStatementInput!) {
    updateStatement(data: $data) {
      uuid
      corporateObjectiveSummary
      corporatePlanScopeSummary
    }
  }
`;